import { FC } from 'react';
// i18next
import { Trans, useTranslation } from 'react-i18next';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { appActions } from 'store/app/appSlice';
import { selectCurrentUser } from 'store/currentUser/currentUserSelectors';
import { selectShowLicenseExpirationAlert } from 'store/app/appSelectors';
// Icons
import { IoMdClose } from "react-icons/io";
// Components
import { IconButton } from './Buttons';
// dayjs
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
dayjs.extend(isSameOrBefore);

const LicenseExpirationAlert:FC = () => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const currentUser = useAppSelector(selectCurrentUser);
  const showLicenseExpirationAlert = useAppSelector(selectShowLicenseExpirationAlert);

  const licenseExpirationDate = currentUser?.account.licenseExpirationDate || null;


  const showAlert = licenseExpirationDate && 
    dayjs(licenseExpirationDate).isSameOrBefore(dayjs().add(14, 'days'), 'day');

  const daysLeft = licenseExpirationDate ?
    dayjs(licenseExpirationDate).diff(dayjs().subtract(1, 'days'), 'day') : null;

  const onClose = () => {
    dispatch(appActions.setShowLicenseExpirationAlert(false));
  }

  const alreadyExpired = daysLeft !== null && daysLeft < 1;
  
  if (!showAlert || !showLicenseExpirationAlert) return null;
  return (
    <div className="bg-yellow-100">
      <div className="container max-w-screen-desktop p-2 flex items-center justify-between gap-4">
        <div className="text-yellow-800 text-xs md:text-sm">
          <Trans
            t={t}
            components={{
              // eslint-disable-next-line jsx-a11y/anchor-has-content
              a: <a href="mailto:sales@quizwizards.com" className="underline hover:text-primary" />
            }}
            values={{ days: daysLeft }}
            i18nKey={`components.licenseExpirationAlert.${alreadyExpired ? 'expiredTitle' : 'title'}`}
          />
        </div>
        <IconButton
          onClick={onClose}
        >
          <IoMdClose className="text-yellow-800" />
        </IconButton>
      </div>
    </div>
  )
};

export default LicenseExpirationAlert;
